var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
/**
 * One successfully assembled draft, ready for the result summary in the modal.
 * Totals are the persisted (re-resolved-at-assemble) values, not the
 * provisional foldout snapshot.
 */
export class CreatedPatientInvoiceSummaryDto {
    invoiceId;
    clusterKey;
    treatmentPlanIds;
    unitCount;
    totalGross;
    currency;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], CreatedPatientInvoiceSummaryDto.prototype, "invoiceId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CreatedPatientInvoiceSummaryDto.prototype, "clusterKey", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], CreatedPatientInvoiceSummaryDto.prototype, "treatmentPlanIds", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], CreatedPatientInvoiceSummaryDto.prototype, "unitCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], CreatedPatientInvoiceSummaryDto.prototype, "totalGross", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CreatedPatientInvoiceSummaryDto.prototype, "currency", void 0);
/**
 * One unit dropped before or during assemble, with the operator-facing reason.
 * Two distinct in-flight reasons live here:
 *
 * - `Bereits einer anderen Rechnung zugewiesen` — a `23505` race: the unit was
 *   spoken-for by a concurrent caller. The unit is dropped, the rest of the
 *   group is reassembled from survivors, the drop is reported.
 * - `Nicht mehr abrechenbar` — the selected unit was not in the reader's
 *   `eligible[]` (stale modal / vanished unit / silently-omitted reason).
 *
 * Unpriceable-with-reason rows are NOT carried here — they were diverted
 * before the create command ran (the reader's `skipped[]` surfaces them on
 * the foldout). This list is strictly about units the operator asked us to
 * bill that we couldn't.
 */
export class CreatePatientInvoicesSkipDto {
    treatmentUnitId;
    reason;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], CreatePatientInvoicesSkipDto.prototype, "treatmentUnitId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CreatePatientInvoicesSkipDto.prototype, "reason", void 0);
/**
 * Per-group outcome summary the modal renders after submit. Per-group atomic:
 * one failing group does not prevent other groups from persisting. The whole
 * payload drives the post-create UI — list `created[]` with totals, list
 * `skipped[]` with reasons, refetch both foldouts, and if exactly one draft
 * was created and nothing skipped open it directly in the detail sidebar.
 */
export class CreatePatientInvoicesResultDto {
    created;
    skipped;
}
__decorate([
    Expose(),
    Type(() => CreatedPatientInvoiceSummaryDto),
    __metadata("design:type", Array)
], CreatePatientInvoicesResultDto.prototype, "created", void 0);
__decorate([
    Expose(),
    Type(() => CreatePatientInvoicesSkipDto),
    __metadata("design:type", Array)
], CreatePatientInvoicesResultDto.prototype, "skipped", void 0);
//# sourceMappingURL=create-patient-invoices-result.response.dto.js.map